import type { RootState } from '@/state';

export const selectAccessToken = ({ auth }: RootState) => auth.accessToken;
export const selectUser = ({ auth }: RootState) => auth.user;
export const selectIsAuthenticated = ({ auth }: RootState) =>
  !!auth.accessToken && !!auth.user;
export const selectLoginError = ({ auth }: RootState) => auth.loginError;
export const selectIsLoggingIn = ({ auth }: RootState) => auth.isLoggingIn;
export const selectIsAuthResolved = ({ auth }: RootState) => auth.isResolved;
export const selectRegisterError = ({ auth }: RootState) => auth.registerError;
export const selectRegisterSuccess = ({ auth }: RootState) =>
  auth.registerSuccess;
export const selectDevVerificationDetails = ({ auth }: RootState) =>
  auth.devVerificationDetails;
